import type { CSSProperties } from 'react';

import { STR } from '../../../../i18n';

import { MATRIX_SHOW_OPTIONS, type MatrixShow, parseMatrixShow } from './model';

/** The toolbar's Show dropdown (FINAL demo `mx-only`): Show every login / Only what needs work. */
export function MatrixShowSelect({
  value,
  onChange,
  style,
}: {
  value: MatrixShow;
  onChange: (value: MatrixShow) => void;
  style: CSSProperties;
}) {
  return (
    <select
      className="field"
      aria-label={STR.access.matrix.showLabel}
      value={value}
      onChange={(event) => {
        onChange(parseMatrixShow(event.target.value));
      }}
      style={style}
    >
      {MATRIX_SHOW_OPTIONS.map((option) => (
        <option key={option} value={option}>
          {STR.access.matrix.show[option]}
        </option>
      ))}
    </select>
  );
}
